import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import '../../../css/components/milestone.css';

const Milestone = ({ data = {} }) => {
    const milestoneRef = useRef(null);

    const animateCounters = () => {
        document.querySelectorAll('.milestone_counter').forEach(counter => {
            const endValue = +counter.dataset.endValue;
            const signAfter = counter.dataset.signAfter || '';

            gsap.to(counter, {
                innerText: endValue,
                duration: 2,
                ease: "power1.inOut",
                snap: { innerText: 1 },
                onUpdate: () => {
                    counter.innerText = Math.floor(counter.innerText) + signAfter;
                },
            });
        });
    };

    useEffect(() => {
        // Membuat observer untuk mengecek apakah milestone terlihat
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Jika milestone terlihat, jalankan animasi
                    animateCounters();
                    // Disconnect observer untuk mencegah animasi dijalankan lagi
                    observer.disconnect();
                }
            });
        }, { threshold: 0.5 }); // Threshold 50% untuk memastikan milestone terlihat setengahnya

        if (milestoneRef.current) {
            observer.observe(milestoneRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <section id="statistic" className="p-12 bg-blue-100">
            <div className="container mx-auto">
                <div className="counter_content">
                    <div className="flex flex-col justify-between items-center milestones md:flex-row" ref={milestoneRef}>
                        <div className="milestone">
                            <div className="milestone_counter" data-end-value={data.people}>0</div>
                            <div className="milestone_text">People</div>
                        </div>
                        <div className="milestone">
                            <div className="milestone_counter" data-end-value={data.extra}>0</div>
                            <div className="milestone_text">Extra</div>
                        </div>
                        <div className="milestone">
                            <div className="milestone_counter" data-end-value={data.artikel} data-sign-after="+">0</div>
                            <div className="milestone_text">Artikel</div>
                        </div>
                        <div className="milestone">
                            <div className="milestone_counter" data-end-value={data.album}>0</div>
                            <div className="milestone_text">Albums</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Milestone;
